/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { InteractSubTypes, XmlaSubscriptionTypeEx } from "../../../api/models";

export interface EditXmlaSubscriptionLevelsDialogData {
  dialogTitle: string;
  isNew: boolean;
  xmlaSubscriptionTypes: XmlaSubscriptionTypeEx[];
  subscriptionLevelId: number;
  subscriptionTypeId: number;
  description: string;
  allowInvoice: boolean;
}

@Component({
  selector: "edit-xmla-subscription-level-dialog",
  styleUrls: ["edit-xmla-subscription-level-dialog.component.css"],
  templateUrl: "./edit-xmla-subscription-level-dialog.component.html",
})
export class EditXmlaSubscriptionLevelsDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditXmlaSubscriptionLevelsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditXmlaSubscriptionLevelsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditSubLevels(params: EditSubLevelsDialogData) {
    var dialogRef = this.dialog.open(EditSubLevelsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
